import React from "react";
import HistogramTotalYieldPerCountry from "../components/HistogramTotalYieldCountry/HistogramTotalYieldPerCountry";

export default function Histogrampage() {
  return (
    <div>
      <HistogramTotalYieldPerCountry />
    </div>
  );
}
